/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Status_TodayInputs */

const en_source_status_today = /** @type {(inputs: Source_Status_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const nl_source_status_today = /** @type {(inputs: Source_Status_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Source_Status_TodayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const source_status_today = /** @type {((inputs?: Source_Status_TodayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Status_TodayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_source_status_today(inputs)
	return en_source_status_today(inputs)
});